import { useNavigate, useSearchParams } from "react-router-dom";
import { ApplicationButton, ApplicationPage, ApplicationSurface, ApplicationViewHeader } from "../../../components/application";

export default function ActivityCreatePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnToken = searchParams.get("returnToken");
  const returnSearch = returnToken ? `?returnToken=${encodeURIComponent(returnToken)}` : "";
  return (
    <ApplicationPage className="av-activity-create" variant="workspace">
      <ApplicationViewHeader contextLabel="Facilitate · Activities" title="Create activity" description="Choose how you want to define the participant experience." />
      {returnToken ? <><p>Creating an activity for an assignment</p><ApplicationButton variant="quiet" onClick={() => navigate(`/app/assignments/new${returnSearch}`)}>Back to assignment</ApplicationButton></> : <ApplicationButton variant="quiet" onClick={() => navigate("/app/facilitate/activities")}>Back to Activities</ApplicationButton>}
      <div className="av-activity-create__choices">
        <ApplicationSurface className="av-activity-create__choice" variant="subtle">
          <div><h2>Build a perceptual activity</h2><p>Choose what participants judge and how they respond for each sample.</p></div>
          <ApplicationButton onClick={() => navigate(`/app/facilitate/activities/new/perceptual${returnSearch}`)}>Build activity</ApplicationButton>
        </ApplicationSurface>
        <ApplicationSurface className="av-activity-create__choice" variant="subtle">
          <div><h2>Use the CAPE-Vr protocol</h2><p>Create an activity using CAPE-Vr’s established questions and response format.</p></div>
          <ApplicationButton onClick={() => navigate(`/app/facilitate/activities/new/cape-vr${returnSearch}`)}>Use CAPE-Vr</ApplicationButton>
        </ApplicationSurface>
      </div>
    </ApplicationPage>
  );
}
